/**
 * @author Charles Blais
 */

import moment from 'moment';

export const COLOR_OPEN = '#A9DFBF';
export const COLOR_CLOSE = '#E6B0AA';
export const COLOR_PLANNED = '#FAF8B2';
export const COLOR_UNKNOWN = '#CCD1D1';

/**
 * Get the status indicator as numeric representation:
 * 
 * -1 = closed
 * 0 = open
 * 1 = will open
 * 
 * @param {*} station 
 * @param {*} timestamp 
 * @returns int 
 */
export const getStatusIndicator = (station, timestamp = moment()) => {
  let status = (station.isOpen(timestamp)) ? 0 : -1;
  if(station.willOpen(timestamp)) status = 1;
  return status;
}

/**
 * Get the status color
 * @param {Station} station 
 * @param {moment} timestamp 
 * @returns string color code
 */
export const getStatusColor = (station, timestamp = moment()) => {
  const status = getStatusIndicator(station, timestamp)
  switch(status) {
    case -1:
      return COLOR_CLOSE;
    case 0:
      return COLOR_OPEN;
    case 1:
      return COLOR_PLANNED;
    default:
      return COLOR_UNKNOWN;
  }
}
